module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-70x70.56a7533dd0953ba9f5706df5a5252454.png";